if (!customElements.get('collapsible-content')) {
class CollapsibleContent extends HTMLElement {
    connectedCallback() {
        const button = this.querySelector("button");
        const content = button.nextElementSibling;

        // Track open state in JS, initialised from the server-rendered HTML.
        let isOpen = button.getAttribute("aria-expanded") === "true";

        const open = () => {
            isOpen = true;
            button.setAttribute("aria-expanded", "true");
            if (content) content.setAttribute("aria-hidden", "false");
        };
        const close = () => {
            isOpen = false;
            button.setAttribute("aria-expanded", "false");
            if (content) content.setAttribute("aria-hidden", "true");
        };

        button.addEventListener("click", () => {
            if (isOpen) { close(); } else { open(); }
        });

        // If external code changes aria-expanded on the button (e.g. variant change logic), revert it to match isOpen
        const observer = new MutationObserver(() => {
            const expected = isOpen ? "true" : "false";
            if (button.getAttribute("aria-expanded") !== expected) {
                button.setAttribute("aria-expanded", expected);
            }
        });
        observer.observe(button, { attributes: true, attributeFilter: ["aria-expanded"] });

        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                this.setAttribute("data-loaded", "");
            });
        });
    }
}

customElements.define("collapsible-content", CollapsibleContent);

}